(function () {
  'use strict';

  if (window.__ppwPdpInitialized) return;
  window.__ppwPdpInitialized = true;

  function formatMoney(cents) {
    var fox = window.FoxTheme;
    if (fox && fox.Currency && typeof fox.Currency.formatMoney === 'function') {
      return fox.Currency.formatMoney(cents, fox.settings && fox.settings.moneyFormat);
    }
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: currency });
  }

  function fill(template, values) {
    return String(template || '').replace(/\[(\w+)\]/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? values[key] : match;
    });
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function readJson(node) {
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  // Match the calculator drawer in hc-custom.js.
  var TRIM_IN = 4;
  var DEFAULT_REPEAT_IN = 24;

  function sum(values) {
    return values.reduce(function (total, value) {
      return total + value;
    }, 0);
  }

  // Rolls for a job. Wallpaper hangs in full-height strips, so the count runs
  // on whole strips per roll, not on area: an offcut shorter than the wall is
  // waste. Each wall is rounded up to whole strips of the roll width. Each
  // strip is the wall height plus trim, rounded up to whole pattern repeats so
  // that every strip starts at the same point in the pattern, and up to one
  // repeat is lost at the start of each roll to line the pattern up. A repeat
  // of 0 means the design needs no matching. The buffer adds whole rolls,
  // rounded down. Measurements are in inches.
  // Kept identical to rollsNeeded() in hc-custom.js; the test in
  // tests/wallpaper-calculator.test.mjs checks both.
  function rollsNeeded(job) {
    var hundredths = function (n) {
      return Math.round(n * 100) / 100;
    };
    var rollWidth = job.rollWidthIn > 0 ? job.rollWidthIn : 24;
    var rollLength = job.rollLengthIn;
    var repeat = job.repeatIn > 0 ? job.repeatIn : 0;
    var height = hundredths(job.heightIn);
    var strips = 0;
    job.widthsIn.forEach(function (widthIn) {
      if (widthIn > 0) strips += Math.ceil(hundredths(widthIn) / rollWidth);
    });
    if (!(strips > 0) || !(height > 0) || !(rollLength > 0)) return null;

    var cut = height + (job.trimIn > 0 ? job.trimIn : 0);
    var stripLength = repeat ? Math.ceil(hundredths(cut / repeat)) * repeat : cut;
    if (stripLength < cut) stripLength += repeat;
    var usable = rollLength - repeat;
    var perRoll = usable >= cut ? Math.floor((usable - cut) / stripLength) + 1 : 0;
    // A strip longer than one roll is pieced from several rolls.
    var rolls = perRoll > 0 ? Math.ceil(strips / perRoll) : strips * Math.ceil((cut + repeat) / rollLength);
    var extra = Math.floor((rolls * (job.bufferPercent > 0 ? job.bufferPercent : 0)) / 100);
    return { rolls: rolls + extra, extra: extra, strips: strips, perRoll: perRoll, stripLengthIn: stripLength };
  }

  function estimateRolls(input, roll) {
    return rollsNeeded({
      heightIn: input.heightIn,
      widthsIn: input.widthsIn,
      rollLengthIn: roll.length * 12,
      rollWidthIn: roll.width,
      repeatIn: input.repeat,
      trimIn: TRIM_IN,
      bufferPercent: input.waste,
    });
  }

  // Feet plus inches, as read off a tape measure, in inches; blank fields count as 0.
  function readInches(row) {
    var ft = parseFloat(row.querySelector('[data-ppw-ft]').value);
    var inches = parseFloat(row.querySelector('[data-ppw-in]').value);
    return (ft > 0 ? ft : 0) * 12 + (inches > 0 ? inches : 0);
  }

  function formatFeet(feet) {
    var rounded = Math.round(feet * 10) / 10;
    return rounded % 1 === 0 ? rounded.toFixed(0) : rounded.toFixed(1);
  }

  // Capital first letter and a full stop, so setting text can be joined as sentences.
  function sentence(text) {
    text = String(text || '').trim();
    if (!text) return '';
    text = text.charAt(0).toUpperCase() + text.slice(1);
    return /[.!?]$/.test(text) ? text : text + '.';
  }

  // 100 -> "8 ft 4 in", 120 -> "10 ft".
  function formatLength(inches) {
    var feet = Math.floor(inches / 12);
    var rest = Math.round(inches - feet * 12);
    if (rest === 12) {
      feet += 1;
      rest = 0;
    }
    return feet + ' ft' + (rest ? ' ' + rest + ' in' : '');
  }

  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added += 1;
    }
    return d;
  }

  function PpwPdp(root) {
    this.root = root;
    this.sectionId = root.getAttribute('data-section');
    this.qtySource = 'default';
    this.qtyInput = root.querySelector('[data-ppw-qty-input]');
    this.atc = root.querySelector('[data-ppw-atc]');
    this.calc = root.querySelector('[data-ppw-calc]');
    this.calcStrings = readJson(root.querySelector('[data-ppw-calc-strings]')) || {};
    this.sticky = document.querySelector('[data-ppw-sticky]');

    this.initGallery();
    this.initZoom();
    this.initQty();
    this.initCalc();
    this.initNote();
    this.initSticky();
    this.initDelivery();
    this.initDelegates();
    this.subscribe();
    this.update();
  }

  PpwPdp.prototype.state = function () {
    return readJson(this.root.querySelector('variant-selects [data-ppw-state]'));
  };

  PpwPdp.prototype.selectLength = function (value) {
    var picker = this.root.querySelector('variant-selects');
    if (!picker) return;
    var radio = Array.prototype.find.call(picker.querySelectorAll('.ppw-lengths input[type="radio"]'), function (input) {
      return input.value === value;
    });
    if (radio) {
      if (radio.checked) return;
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var select = picker.querySelector('select.ppw-select');
    if (!select) return;
    var option = Array.prototype.find.call(select.options, function (o) {
      return o.value === value;
    });
    if (!option || option.selected) return;
    select.value = value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  };

  // Least the shopper may order of the selected variant. state.min comes from
  // snippets/mural-minimum-rule.liquid (2 for 48-inch repeat rolls), else 1.
  PpwPdp.prototype.minQuantity = function (state) {
    state = state || this.state();
    return Math.max(1, (state && parseInt(state.min, 10)) || 1);
  };

  PpwPdp.prototype.quantity = function () {
    return Math.max(this.minQuantity(), parseInt(this.qtyInput && this.qtyInput.value, 10) || 1);
  };

  // A manual value below the minimum snaps back and opens the shared minimum dialog.
  // Do not copy the minimum to the input's min attribute: the Limit Purchase app
  // resets the value to 1 when it equals that attribute.
  PpwPdp.prototype.setQuantity = function (n, source) {
    if (!this.qtyInput) return;
    var min = this.minQuantity();
    n = Math.floor(n) || 1;
    if (n < min && source === 'manual') this.notifyMinimum();
    this.qtyInput.value = Math.max(min, n);
    this.qtySource = source;
  };

  PpwPdp.prototype.notifyMinimum = function () {
    var guard = window.PaintedMuralMinimum;
    if (guard && typeof guard.notify === 'function') guard.notify({ allowRemove: false });
  };

  PpwPdp.prototype.initGallery = function () {
    var root = this.root;
    var mainImg = root.querySelector('[data-ppw-main-img]');
    var thumbs = root.querySelectorAll('[data-ppw-thumb]');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (mainImg) {
          mainImg.setAttribute('src', thumb.getAttribute('data-src'));
          mainImg.setAttribute('srcset', thumb.getAttribute('data-srcset') || '');
          mainImg.setAttribute('alt', thumb.getAttribute('data-alt') || '');
        }
        thumbs.forEach(function (t) {
          var active = t === thumb;
          t.classList.toggle('is-active', active);
          if (active) t.setAttribute('aria-current', 'true');
          else t.removeAttribute('aria-current');
        });
      });
    });

    var carousel = root.querySelector('[data-ppw-carousel]');
    var dotsWrap = root.querySelector('[data-ppw-dots]');
    if (!carousel || !dotsWrap) return;
    var dots = dotsWrap.querySelectorAll('.ppw-gallery-dot');
    var raf = 0;
    carousel.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var idx = Math.round(carousel.scrollLeft / (carousel.clientWidth || 1));
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === idx);
        });
      });
    });
  };

  /* Click-to-zoom uses the theme's PhotoSwipe, the same lightbox as the default product page. It
     loads on first use, so shoppers who never zoom do not download it. */
  var zoomLoader = null;

  function loadZoom(gallery) {
    if (window.FoxTheme && window.FoxTheme.PhotoSwipeLightbox) return Promise.resolve();
    if (!zoomLoader) {
      var load = function (el) {
        return new Promise(function (resolve, reject) {
          el.onload = resolve;
          el.onerror = reject;
          document.head.appendChild(el);
        });
      };
      var css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = gallery.getAttribute('data-ppw-zoom-css');
      var js = document.createElement('script');
      js.src = gallery.getAttribute('data-ppw-zoom-js');
      zoomLoader = Promise.all([load(css), load(js)]).catch(function (error) {
        zoomLoader = null;
        throw error;
      });
    }
    return zoomLoader;
  }

  function registerZoomUi(pswp, multiple) {
    var arrow = '<path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path>';
    if (multiple) {
      pswp.ui.registerElement({
        name: 'next',
        ariaLabel: 'Next slide',
        order: 3,
        isButton: true,
        html: '<svg class="pswp-icon-next flip-x" viewBox="0 0 100 100">' + arrow + '</svg>',
        onClick: function () { pswp.next(); },
      });
      pswp.ui.registerElement({
        name: 'prev',
        ariaLabel: 'Previous slide',
        order: 1,
        isButton: true,
        html: '<svg class="pswp-icon-prev rtl-flip-x" viewBox="0 0 100 100">' + arrow + '</svg>',
        onClick: function () { pswp.prev(); },
      });
    }
    pswp.ui.registerElement({
      name: 'close-zoom',
      ariaLabel: 'Close zoom image',
      order: 2,
      isButton: true,
      html:
        '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
      onClick: function () { pswp.close(); },
    });
  }

  PpwPdp.prototype.initZoom = function () {
    var gallery = this.root.querySelector('[data-ppw-zoom]');
    if (!gallery) return;
    var items = readJson(gallery.querySelector('[data-ppw-zoom-items]')) || [];
    var button = gallery.querySelector('[data-ppw-zoom-open]');
    var mainImg = gallery.querySelector('[data-ppw-main-img]');
    var thumbs = gallery.querySelectorAll('[data-ppw-thumb]');
    var carousel = gallery.querySelector('[data-ppw-carousel]');
    var slides = gallery.querySelectorAll('.ppw-gallery-slide');

    function onPhone() {
      return !!carousel && carousel.offsetParent !== null;
    }

    // Which list item the main image shows (-1 when it is a variant image outside the list).
    function mainIndex() {
      var key = mainImg && mainImg.getAttribute('src');
      for (var i = 0; i < items.length; i++) {
        if (items[i].key === key) return i;
      }
      return -1;
    }

    function syncLabel() {
      if (!button) return;
      var index = Math.max(mainIndex(), 0) + 1;
      button.setAttribute('aria-label', (button.getAttribute('data-label') || '').replace('[index]', index));
    }

    // The element the lightbox grows out of and shrinks back into.
    function originFor(source, index) {
      if (source !== items) return mainImg;
      if (onPhone()) return slides[index] && slides[index].querySelector('img');
      return mainIndex() === index ? mainImg : null;
    }

    // After closing, leave the gallery on the image the shopper ended on.
    function showIndex(index) {
      if (onPhone()) {
        carousel.scrollLeft = index * carousel.clientWidth;
      } else if (thumbs[index] && mainIndex() !== index) {
        thumbs[index].click();
      }
    }

    function open(source, index) {
      loadZoom(gallery)
        .then(function () {
          var fox = window.FoxTheme;
          var lightbox = new fox.PhotoSwipeLightbox({
            dataSource: source.map(function (item) {
              return { src: item.src, width: item.w, height: item.h, alt: item.alt };
            }),
            pswpModule: fox.PhotoSwipe,
            bgOpacity: 1,
            arrowPrev: false,
            arrowNext: false,
            zoom: false,
            close: false,
            counter: false,
            preloader: false,
          });
          lightbox.addFilter('thumbEl', function (el, data, i) {
            return originFor(source, i) || el;
          });
          lightbox.addFilter('placeholderSrc', function (src, content) {
            var el = originFor(source, content.index);
            return el ? el.currentSrc || el.src : src;
          });
          lightbox.on('uiRegister', function () {
            registerZoomUi(lightbox.pswp, source.length > 1);
          });
          lightbox.on('close', function () {
            if (source === items) showIndex(lightbox.pswp.currIndex);
          });
          lightbox.init();
          lightbox.loadAndOpen(index);
        })
        .catch(function () {});
    }

    syncLabel();
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', syncLabel);
    });

    gallery.addEventListener('click', function (event) {
      var slide = event.target.closest('.ppw-gallery-slide');
      if (slide) {
        open(items, Array.prototype.indexOf.call(slides, slide));
        return;
      }
      if (!button || !event.target.closest('[data-ppw-zoom-open]')) return;
      var index = mainIndex();
      if (index >= 0) {
        open(items, index);
      } else {
        open([{ src: button.getAttribute('data-zoom-src'), w: +button.getAttribute('data-zoom-w'), h: +button.getAttribute('data-zoom-h'), alt: mainImg ? mainImg.alt : '' }], 0);
      }
    });

    // Start the download as soon as a shopper reaches for the gallery.
    ['pointerenter', 'touchstart', 'focusin'].forEach(function (type) {
      gallery.addEventListener(
        type,
        function () {
          loadZoom(gallery).catch(function () {});
        },
        { once: true, passive: true }
      );
    });
  };

  PpwPdp.prototype.initQty = function () {
    var self = this;
    var wrap = this.root.querySelector('[data-ppw-qty]');
    if (!wrap || !this.qtyInput) return;
    wrap.querySelector('[data-ppw-qty-dec]').addEventListener('click', function () {
      self.setQuantity(self.quantity() - 1, 'manual');
      self.update();
    });
    wrap.querySelector('[data-ppw-qty-inc]').addEventListener('click', function () {
      self.setQuantity(self.quantity() + 1, 'manual');
      self.update();
    });
    this.qtyInput.addEventListener('input', function () {
      self.qtyInput.value = self.qtyInput.value.replace(/[^0-9]/g, '');
      self.qtySource = 'manual';
      self.update();
    });
    this.qtyInput.addEventListener('blur', function () {
      var typed = parseInt(self.qtyInput.value, 10);
      self.setQuantity(isNaN(typed) ? self.minQuantity() : typed, self.qtySource);
      self.update();
    });
  };

  PpwPdp.prototype.initCalc = function () {
    var self = this;
    if (!this.calc) return;
    this.wallsList = this.calc.querySelector('[data-ppw-calc-walls]');
    this.addWallBtn = this.calc.querySelector('[data-ppw-wall-add]');
    this.maxWalls = parseInt(this.wallsList && this.wallsList.getAttribute('data-max'), 10) || 8;

    this.calc.addEventListener('input', function (event) {
      if (event.target.tagName !== 'INPUT') return;
      self.calcTouched = true;
      self.update();
    });

    if (this.addWallBtn) {
      this.addWallBtn.addEventListener('click', function () {
        self.addWall();
      });
    }

    this.calc.addEventListener('click', function (event) {
      var remove = event.target.closest('[data-ppw-wall-remove]');
      if (!remove) return;
      var row = remove.closest('[data-ppw-wall]');
      var rows = self.wallRows();
      var index = rows.indexOf(row);
      if (!row || rows.length < 2) return;
      row.remove();
      self.renumberWalls();
      var remaining = self.wallRows();
      var focusRow = remaining[Math.min(index, remaining.length - 1)];
      if (focusRow) focusRow.querySelector('[data-ppw-ft]').focus();
      self.calcTouched = true;
      self.update();
    });

    this.renumberWalls();
  };

  PpwPdp.prototype.wallRows = function () {
    return this.wallsList ? Array.prototype.slice.call(this.wallsList.querySelectorAll('[data-ppw-wall]')) : [];
  };

  PpwPdp.prototype.addWall = function () {
    var rows = this.wallRows();
    if (!rows.length || rows.length >= this.maxWalls) return;
    var row = rows[0].cloneNode(true);
    row.querySelectorAll('input').forEach(function (input) {
      input.value = '';
    });
    this.wallsList.appendChild(row);
    this.renumberWalls();
    row.querySelector('[data-ppw-ft]').focus();
  };

  PpwPdp.prototype.renumberWalls = function () {
    var s = this.calcStrings;
    var rows = this.wallRows();
    var single = rows.length < 2;
    rows.forEach(function (row, i) {
      var label = fill(s.wall || 'Wall [number]', { number: i + 1 });
      row.querySelector('[data-ppw-wall-label]').textContent = label;
      row.querySelector('[data-ppw-ft]').setAttribute('aria-label', label + ', ' + (s.feet || 'feet'));
      row.querySelector('[data-ppw-in]').setAttribute('aria-label', label + ', ' + (s.inches || 'inches'));
      var remove = row.querySelector('[data-ppw-wall-remove]');
      remove.hidden = single;
      remove.setAttribute('aria-label', fill(s.removeWall || 'Remove wall [number]', { number: i + 1 }));
    });
    if (this.addWallBtn) this.addWallBtn.hidden = rows.length >= this.maxWalls;
  };

  // The (i) after the calculator intro. Hover and keyboard focus are CSS; a tap
  // toggles it for touch screens, and Escape or a tap elsewhere closes it.
  PpwPdp.prototype.initNote = function () {
    var note = this.root.querySelector('[data-ppw-calc-note]');
    if (!note) return;
    var btn = note.querySelector('[data-ppw-calc-note-btn]');
    var close = function () {
      note.classList.remove('is-open');
    };
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      note.classList.remove('is-dismissed');
      note.classList.toggle('is-open');
    });
    document.addEventListener('click', function (event) {
      if (!note.contains(event.target)) close();
    });
    note.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      close();
      note.classList.add('is-dismissed');
    });
    var undismiss = function () {
      note.classList.remove('is-dismissed');
    };
    btn.addEventListener('blur', undismiss);
    note.addEventListener('mouseleave', undismiss);
  };

  PpwPdp.prototype.readCalc = function () {
    if (!this.calc) return null;
    var heightRow = this.calc.querySelector('[data-ppw-calc-height]');
    var heightIn = heightRow ? readInches(heightRow) : 0;
    var widthsIn = this.wallRows()
      .map(function (row) {
        return readInches(row);
      })
      .filter(function (widthIn) {
        return widthIn > 0;
      });
    if (!widthsIn.length || !(heightIn > 0)) return null;
    // Written by snippets/wallpaper-repeat.liquid; blank when the product does not say.
    var repeat = parseFloat(this.calc.getAttribute('data-repeat'));
    return {
      widthsIn: widthsIn,
      heightIn: heightIn,
      repeat: repeat >= 0 ? repeat : DEFAULT_REPEAT_IN,
      waste: parseFloat(this.calc.getAttribute('data-waste')) || 0,
    };
  };

  PpwPdp.prototype.renderCalc = function (state) {
    if (!this.calc) return;
    var s = this.calcStrings;
    var out = this.calc.querySelector('[data-ppw-calc-result]');
    var summary = this.calc.querySelector('[data-ppw-calc-summary]');
    var input = this.readCalc();
    if (!input || !state) {
      out.hidden = true;
      out.innerHTML = '';
      if (summary) summary.textContent = '';
      return;
    }
    if (!state.isRoll) {
      out.hidden = false;
      out.innerHTML = '<p>' + escapeHtml(s.chooseRoll || '') + '</p>';
      if (summary) summary.textContent = '';
      return;
    }

    var need = estimateRolls(input, { width: state.rollWidth, length: state.rollLength });
    if (!need) {
      out.hidden = true;
      out.innerHTML = '';
      if (summary) summary.textContent = '';
      return;
    }
    var min = this.minQuantity(state);
    var rolls = Math.max(min, need.rolls);
    var total = rolls * state.price;
    var widthIn = sum(input.widthsIn);
    var headline = rolls === 1 ? fill(s.rollsOne, { length: state.rollLength }) : fill(s.rollsOther, { rolls: rolls, length: state.rollLength });
    var detail = fill(s.detail, {
      drops: need.strips === 1 ? '1 drop' : need.strips + ' drops',
      strips: need.strips,
      strip_length: formatLength(need.stripLengthIn),
      length: state.rollLength,
      per_roll: need.perRoll === 1 ? '1 drop' : need.perRoll > 1 ? need.perRoll + ' drops' : 'less than 1 full drop',
      paper: rolls * state.rollSqft,
      wall: Math.round((widthIn * input.heightIn) / 144),
    });
    detail = sentence(detail);
    if (input.widthsIn.length > 1 && s.walls) {
      detail += ' ' + sentence(fill(s.walls, { walls: input.widthsIn.length, width: formatFeet(widthIn / 12) }));
    }

    var best = null;
    (state.rolls || []).forEach(function (roll) {
      if (roll.value === state.sizeValue || !roll.available) return;
      var alt = estimateRolls(input, roll);
      if (!alt) return;
      var n = Math.max(min, alt.rolls);
      var cost = n * roll.price;
      if (total - cost >= 100 && (!best || cost < best.cost)) best = { roll: roll, n: n, cost: cost };
    });

    var html =
      '<div class="ppw-calc-answer"><strong>' +
      escapeHtml(headline) +
      '</strong><span>' +
      escapeHtml(formatMoney(total)) +
      '</span></div>';

    if (best && s.alternative) {
      html +=
        '<p class="ppw-calc-saving">' +
        escapeHtml(
          fill(s.alternative, {
            rolls: best.n,
            length: best.roll.length,
            cost: formatMoney(best.cost),
            saving: formatMoney(total - best.cost),
          })
        ) +
        ' <button type="button" class="ppw-link" data-ppw-select-length="' +
        escapeHtml(best.roll.value) +
        '">' +
        escapeHtml(fill(s.switchTo, { length: best.roll.length })) +
        '</button></p>';
    }

    html += '<p>' + escapeHtml(detail) + '</p>';

    out.hidden = false;
    out.innerHTML = html;
    if (summary) summary.textContent = fill(rolls === 1 && s.summaryOne ? s.summaryOne : s.summary, { rolls: rolls });

    if (this.calcTouched || this.qtySource === 'calc') {
      this.calcTouched = false;
      this.setQuantity(rolls, 'calc');
    }
  };

  PpwPdp.prototype.initDelivery = function () {
    var el = this.root.querySelector('[data-ppw-delivery]');
    if (!el) return;
    var processing = parseInt(el.getAttribute('data-processing'), 10) || 0;
    var processingMax = Math.max(processing, parseInt(el.getAttribute('data-processing-max'), 10) || 0);
    var transitMin = parseInt(el.getAttribute('data-transit-min'), 10) || 0;
    var transitMax = Math.max(transitMin, parseInt(el.getAttribute('data-transit-max'), 10) || 0);
    var today = new Date();
    var locale = document.documentElement.lang || undefined;
    var start = addBusinessDays(today, processing + transitMin);
    var end = addBusinessDays(today, processingMax + transitMax);
    var sameMonth = start.getMonth() === end.getMonth();
    var text = fill(el.getAttribute('data-template'), {
      start: start.toLocaleDateString(locale, { month: 'short', day: 'numeric' }),
      end: end.toLocaleDateString(locale, sameMonth ? { day: 'numeric' } : { month: 'short', day: 'numeric' }),
    });
    el.querySelector('[data-ppw-delivery-text]').textContent = text;
    el.hidden = false;
  };

  PpwPdp.prototype.update = function () {
    var state = this.state();
    this.renderCalc(state);
    if (!state) return;

    var total = state.available ? formatMoney(state.price * this.quantity()) : '';
    var totalEl = this.root.querySelector('[data-ppw-atc-total]');
    if (totalEl) totalEl.textContent = total;

    if (this.atc) {
      var label = this.atc.querySelector('.ppw-atc-label');
      if (label) {
        label.textContent = state.available ? this.atc.getAttribute('data-label') : this.atc.getAttribute('data-sold-out');
      }
    }

    if (this.sticky) {
      var stickyTotal = this.sticky.querySelector('[data-ppw-sticky-total]');
      if (stickyTotal) stickyTotal.textContent = total;
      var stickyAdd = this.sticky.querySelector('[data-ppw-sticky-add]');
      if (stickyAdd) stickyAdd.disabled = !state.available;
      var sub = this.sticky.querySelector('[data-ppw-sticky-sub]');
      if (sub && state.title) sub.textContent = state.title === 'Default Title' ? '' : state.title;
    }
  };

  PpwPdp.prototype.initSticky = function () {
    var buy = this.root.querySelector('[data-ppw-buy]');
    var sticky = this.sticky;
    if (!buy || !sticky || !('IntersectionObserver' in window)) return;
    sticky.removeAttribute('hidden');
    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0, rootMargin: '-80px 0px 0px 0px' }
    ).observe(buy);

    var form = this.root.querySelector('form.ppw-form');
    var add = sticky.querySelector('[data-ppw-sticky-add]');
    if (form && add) {
      add.addEventListener('click', function () {
        var submit = form.querySelector('[type="submit"]');
        if (typeof form.requestSubmit === 'function') form.requestSubmit(submit || undefined);
        else form.submit();
      });
    }
  };

  PpwPdp.prototype.applyTryMaterial = function (select) {
    var container = select.closest('[data-ppw-try]');
    var map = readJson(container && container.querySelector('[data-ppw-try-map]'));
    if (!map) return;
    var byKind = map[select.value] || {};
    container.querySelectorAll('form[data-ppw-try-kind]').forEach(function (form) {
      var entry = byKind[form.getAttribute('data-ppw-try-kind')];
      form.hidden = !entry;
      if (!entry) return;
      form.querySelector('input[name="id"]').value = entry.id;
      var mat = form.querySelector('[data-ppw-try-mat]');
      if (mat) mat.textContent = select.value;
      var price = form.querySelector('[data-ppw-try-price]');
      if (price) {
        var strike = entry.compare ? '<s>' + escapeHtml(entry.compare) + '</s> ' : '';
        if (entry.charged) {
          /* Trade customers: an MSRP slot the section's trade script fills in. */
          strike =
            '<s data-ppw-msrp="' + Number(entry.id) + '" data-ppw-charged="' + Number(entry.charged) + '"' +
            (entry.compare ? '' : ' hidden') + '>' + escapeHtml(entry.compare || '') + '</s> ';
        }
        price.innerHTML = strike + escapeHtml(entry.price);
      }
      var button = form.querySelector('button[type="submit"]');
      if (button) {
        button.disabled = !entry.available;
        button.textContent = entry.available ? button.getAttribute('data-label') : button.getAttribute('data-sold-out');
      }
    });
  };

  PpwPdp.prototype.initDelegates = function () {
    var self = this;
    this.root.addEventListener('change', function (event) {
      var select = event.target.closest('[data-ppw-try-material]');
      if (select) self.applyTryMaterial(select);
    });
    this.root.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-ppw-select-length]');
      if (!trigger) return;
      self.selectLength(trigger.getAttribute('data-ppw-select-length'));
    });
  };

  PpwPdp.prototype.onVariantChange = function (html) {
    if (html) {
      this.root.querySelectorAll('[data-ppw-refresh][id]').forEach(function (current) {
        var fresh = html.getElementById(current.id);
        if (fresh) current.innerHTML = fresh.innerHTML;
      });
    }
    // Re-applies the new variant's minimum to the quantity input.
    this.setQuantity(this.quantity(), this.qtySource);
    this.update();
  };

  PpwPdp.prototype.subscribe = function () {
    var self = this;
    var fox = window.FoxTheme;
    if (fox && fox.pubsub && fox.pubsub.PUB_SUB_EVENTS) {
      fox.pubsub.subscribe(fox.pubsub.PUB_SUB_EVENTS.variantChange, function (event) {
        var data = (event && event.data) || {};
        if (data.sectionId && data.sectionId !== self.sectionId) return;
        self.onVariantChange(data.html);
      });
    } else {
      document.addEventListener('variant:changed', function () {
        self.onVariantChange(null);
      });
    }
  };

  function initAll() {
    document.querySelectorAll('[data-ppw-pdp]').forEach(function (root) {
      if (root.__ppw) return;
      root.__ppw = new PpwPdp(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
